/* @flow */

import React from "react";
import { Button as ButtonComponent } from "@crossroads/ui-components";

import styles from "./styles.scss";
import cn from "classnames";

type Props = {
  children: React$Node,
  className?: string,
};

const Button = ({ className, children, ...props }: Props): React$Node => {
  return (
    <ButtonComponent
      {...props}
      className={cn(styles.button, className)}
    >
      <span className={styles.content}>
        {children}
      </span>
      <span className={styles.content__left} />
      <span className={styles.content__right} />
    </ButtonComponent>
  );
};

export default Button;
